import React, { FC, memo } from 'react';
import Schema from './Schema';
import { useTranslation } from '../../utils/translations';
import { DEFAULT_PUBLIC_DOMAIN_URL } from '../../config';

type Props = {
  socialMediaUrls?: string[];
  publicDomainUrl?: string;
};

const OrganizationSchema: FC<Props> = ({
  socialMediaUrls,
  publicDomainUrl
}) => {
  const { translate } = useTranslation();

  const sameAs = socialMediaUrls?.map((url) => translate(url)) ?? [];
  const origin = publicDomainUrl || DEFAULT_PUBLIC_DOMAIN_URL;
  const logo = `${origin}/static/ca/organization-logo.png`;

  return (
    <Schema
      data={{
        '@type': 'Organization',
        name: translate('organization_schema_brand'),
        brand: translate('organization_schema_brand'),
        url: origin,
        logo,
        sameAs,
        description: translate('organization_schema_description'),
        knowsAbout: translate('organization_schema_knows_about'),
        legalName: translate('organization_schema_legal_name'),
        address: {
          '@type': 'PostalAddress',
          addressCountry: translate('organization_schema_address_country'),
          addressLocality: translate('organization_schema_address_locality'),
          postalCode: translate('organization_schema_postal_code'),
          streetAddress: translate('organization_schema_street_address'),
          addressRegion: translate('organization_schema_address_region')
        },
        contactPoint: {
          '@type': 'ContactPoint',
          url: translate('organization_schema_contact_point_url'),
          contactType: translate('organization_schema_contact_type')
        }
      }}
      testId="OrganizationSchema"
    />
  );
};

export default memo(OrganizationSchema);
